import { Component, OnInit, Input  } from '@angular/core';
import { HomepageService } from '../../../services/homepage.service';

@Component({
  selector: 'app-resource-list',
  templateUrl: './resource-list.component.html',
  styleUrls: ['./resource-list.component.css']
})
export class ResourceListComponent implements OnInit {

 constructor( private homepageService: HomepageService ) {}
 resourcelists: any = [];
 @Input() buId: number;
 ngOnInit() {
 	this.getSavedConfig();
 }
 	getSavedConfig(){
    let getwidgetsSettingDataSave =  this.homepageService.getwidgetsSettingDataSave();
    getwidgetsSettingDataSave.data.forEach(evt => {
            if(evt.code == 'RR' && this.buId  == evt.id){
            this.resourcelists = evt.content;                         
             }            
          });
    }

   

}
